@if (i18n.ready()) {
<router-outlet />
}